import { Component, Input, Output, EventEmitter, OnInit } from 'ng-metadata/core';
import './source-country.component.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentSourceCountry
 * @module mw.components.contentDocuments
 *
 * @param {string} [country-code] - A document title.  This can be an HTML string.
 *
 * @description
 * `<mw-content-document-source-country>` provides a means for displaying the country a document is sourced from.
 *
 * @usage
 * <hljs hljs-language="html">
 *
 *   <mw-content-document-source-country country-code="US"></mw-content-document-source-country>
 *
 * </hljs>
 *
 */
@Component({
    selector: 'mw-content-document-source-country',
    template: `
        <span ng-if="::$ctrl.countryCode" class="mw-content-document-source-country">{{ ::$ctrl.countryCode | uppercase }}</span>
    `,
    legacy: {
        transclude: true
    }
})
export class SourceCountryComponent implements OnInit {
    @Input('<') countryCode: string;

    constructor() {
        'ngInject';
    }

    ngOnInit() {
        // 'zz' means unkown country
        if(this.countryCode === 'zz') {
            this.countryCode = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/source-country/source-country.component.ts